import { FiEdit2 } from 'react-icons/fi';
import { formatDateCST, formatPhone } from '../../../../utlis';
import MyTable from '../../../../components/MyTable';


const FacultyTable = ({ data, onEditFaculty, pageSize, onPageSizeChange }) => {
  // Transform data to ensure consistent field names
  const transformedData = data.map((faculty) => ({
    id: faculty.faculty_id || faculty.id || '',
    facultyName: `${faculty.first_name || ''} ${faculty.last_name || ''}`.trim() || 'N/A',
    email: faculty.email || '',
    phone: faculty.phone || '',
    totalEnrollment: faculty.total_enrollment || 0,
    status: faculty.status || '',
    createdBy: faculty.created_by || '',
    created: faculty.created || '',
    updatedBy: faculty.updated_by || '',
    updated: faculty.updated || '',
  }));

  const columns = [
    {
      name: 'id',
      label: 'ID',
      options: {
        display: false,
      },
    },
    {
      name: 'facultyName',
      label: 'Faculty Name',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta) => {
          const id = tableMeta.rowData[0];
          return (
            <h3
              onClick={() => onEditFaculty(id)}
              className="text-base font-bold text-auxiliary-800 cursor-pointer hover:underline"
            >
              {value || 'N/A'}
            </h3>
          );
        },
      },
    },
    {
      name: 'email',
      label: 'Email',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <p className="text-text-hint">{value || 'N/A'}</p>
        ),
      },
    },
    {
      name: 'phone',
      label: 'Phone',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <p className="text-text-hint">{value ? formatPhone(value) : 'N/A'}</p>
        ),
      },
    },
    {
      name: 'totalEnrollment',
      label: 'Total Enrollment',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => value || '0',
      },
    },
    {
      name: 'status',
      label: 'Status',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="font-bold">{value || 'N/A'}</span>
        ),
      },
    },
    {
      name: 'createdBy',
      label: 'Created By',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => value || 'N/A',
      },
    },
    {
      name: 'created',
      label: 'Date Created',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (value ? formatDateCST(value) : 'N/A'),
      },
    },
    {
      name: 'updatedBy',
      label: 'Updated By',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => value || 'N/A',
      },
    },
    {
      name: 'updated',
      label: 'Updated Date',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (value ? formatDateCST(value) : 'N/A'),
      },
    },
    {
      name: 'actions',
      label: 'Actions',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const facultyId = tableMeta.rowData[0];
          return (
            <button
              onClick={() => onEditFaculty(facultyId)}
              className="p-2 hover:bg-gray-200 rounded-full"
              title="Edit Faculty"
            >
              <FiEdit2 size={16} className="text-secondary-700" />
            </button>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    responsive: 'standard',
    rowsPerPage: pageSize,
    rowsPerPageOptions: [5, 10, 15, 20, 50],
    onChangeRowsPerPage: (numberOfRows) => onPageSizeChange(numberOfRows),
    selectableRows: 'none',
    elevation: 0,
    download: true,
    print: true,
    search: false,
    viewColumns: true,
    filter: true,
  };

  return (
    <div className="w-full overflow-x">
      <MyTable
        title=""
        data={transformedData}
        columns={columns}
        options={options}
      />
    </div>
  );
};

export default FacultyTable;
